"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = exports.TEST_ID_MODAL_CLOSE = exports.TEST_ID_MODAL = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var color_1 = require("@theme-ui/color");
var react_1 = require("react");
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var theme_1 = require("../../../theme");
var utils_1 = require("../../utils");
exports.TEST_ID_MODAL = "modal";
exports.TEST_ID_MODAL_CLOSE = "modalClose";
var MODAL_Z_INDEX = 2;
function Modal(_a) {
    var title = _a.title, _b = _a.closeAction, closeAction = _b === void 0 ? function () { } : _b, _c = _a.closeTitle, closeTitle = _c === void 0 ? "" : _c, _d = _a.showCloseButton, showCloseButton = _d === void 0 ? true : _d, _e = _a.disableBackgroundClose, disableBackgroundClose = _e === void 0 ? false : _e, csx = _a.csx, children = _a.children;
    var backgroundRef = react_1.useRef(null);
    var _f = react_1.useState(false), mouseDownOnModal = _f[0], setMouseDownOnModal = _f[1];
    // Prevent close action through event bubbling, except on background
    var backgroundClose = function (event) {
        if (event.target === backgroundRef.current && !mouseDownOnModal) {
            closeAction(event);
        }
    };
    // Track whether mouse down was on the modal or the background
    var handleMouseDown = function (event) {
        if (event.target !== backgroundRef.current) {
            setMouseDownOnModal(true);
        }
        else {
            setMouseDownOnModal(false);
        }
    };
    return (theme_ui_1.jsx(theme_ui_1.Box, { ref: backgroundRef, "data-testid": exports.TEST_ID_MODAL, onClick: disableBackgroundClose ? utils_1.noop : backgroundClose, onMouseDown: handleMouseDown, sx: __assign({ background: color_1.alpha(theme_1.theme.colors.secondary, 0.6), height: "100%", left: 0, position: "fixed", top: 0, width: "100%", zIndex: MODAL_Z_INDEX }, csx), variant: "primaryCols" },
        theme_ui_1.jsx(theme_ui_1.Box, { sx: {
                alignSelf: "center",
                background: theme_1.theme.colors.offBlack,
                borderRadius: 3,
                boxShadow: "0 0 28px #24252C",
                display: "inline-block",
                left: "50%",
                maxWidth: ["100%", "90%"],
                maxHeight: "100%",
                px: [1, 5],
                py: 4,
                position: "relative",
                top: "50%",
                transform: "translate(-50%, -50%)",
                overflow: "auto"
            } },
            showCloseButton &&
                theme_ui_1.jsx(__1.Close, { "data-testid": exports.TEST_ID_MODAL_CLOSE, csx: {
                        outline: "none",
                        position: "absolute",
                        right: 4,
                        top: "38px"
                    }, onClick: closeAction, title: closeTitle }),
            theme_ui_1.jsx(theme_ui_1.Heading, { as: "h2", sx: {
                    variant: "text.h4",
                    lineHeight: "normal",
                    mr: 3,
                    mt: 0
                } }, title),
            children)));
}
exports.Modal = Modal;
;
